import React from 'react';
import { SpinnerImage } from './loading-spinner.styles';

export const LoadingSpinner = () => (
  <SpinnerImage data-testid="loading-spinner" />
);

export default LoadingSpinner;
